module.exports = __webpack_public_path__ + "img/leva-e-traz.9f991374.png";